import React from 'react';

class Open extends React.Component {
  constructor(props) {
    super(props);
  }

  open(event) {
    window.location.protocol = 'wimit:';
  };

  render() {
    return (
      <React.Fragment>
        <input className="u-full-width button button-primary"
                    type="submit"
                   value="Open invite in the app"
                 onClick={this.open} />
      </React.Fragment>
    )
  }
}

export default Open;
